"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _validate = require("@/utils/validate");

var _dialog = require("@/libs/dialog");

var _order = require("@/api/order");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = {
  name: "PriceChange",
  components: {},
  props: {
    change: Boolean,
    orderInfo: {
      type: Object,
      default: null
    },
    status: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      focus: false,
      price: 0,
      refundPrice: 0,
      remark: "",
      reason: ''
    };
  },
  watch: {
    orderInfo: function orderInfo() {
      this.price = this.orderInfo.payPrice;
      this.refundPrice = this.orderInfo.payPrice;
      this.remark = this.orderInfo.remark;
    }
  },
  created: function created() {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/assets/js/media_750'));
    });
  },
  methods: {
    priceChange: function priceChange() {
      this.focus = true;
    },
    close: function close() {
      this.price = this.orderInfo.payPrice;
      this.$emit("closechange", false);
    },
    save: function save() {
      if (this.status === 3) {
        this.refuse();
      } else {
        this.savePrice({
          price: this.price,
          refundPrice: this.refundPrice,
          type: 1,
          remark: this.remark,
          orderId: this.orderInfo.orderId
        });
      }
    },
    savePrice: function () {
      var _savePrice = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(opt) {
        var _this = this;

        var that, data, price, refundPrice, refundStatus, remark;
        return _index.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this, data = {}, price = opt.price, refundPrice = opt.refundPrice, refundStatus = that.orderInfo.refundStatus, remark = opt.remark;

                if (!(that.status == 0 && refundStatus === 0)) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return this.$validator({
                  price: [(0, _validate.required)(_validate.required.message("金额")), (0, _validate.num)(_validate.num.message("金额"))]
                }).validate({
                  price: price
                });

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context.t0));

              case 10:
                data.payPrice = price;
                data.orderNo = opt.orderId;
                (0, _order.updatePriceApi)(data).then(function () {
                  // that.change = false;
                  _this.$emit("closechange", false);

                  that.$dialog.success("改价成功"); // that.$emit('init');
                  // that.init();
                }).catch(function (error) {
                  that.$dialog.error(error.message);
                });
                _context.next = 41;
                break;

              case 15:
                if (!(that.status == 2 && refundStatus === 1)) {
                  _context.next = 30;
                  break;
                }

                _context.prev = 16;
                _context.next = 19;
                return this.$validator({
                  refundPrice: [(0, _validate.required)(_validate.required.message("金额")), (0, _validate.num)(_validate.num.message("金额"))]
                }).validate({
                  refundPrice: refundPrice
                });

              case 19:
                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](16);
                return _context.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context.t1));

              case 24:
                data.amount = refundPrice;
                data.type = opt.type;
                data.orderNo = opt.orderId;
                (0, _order.orderRefundApi)(data).then(function (res) {
                  _this.$emit("closechange", false); // that.change = false;


                  that.$dialog.success('退款成功'); // that.init();
                  // that.$emit('init');
                }, function (err) {
                  _this.$emit("closechange", false);

                  that.$dialog.error(err.message);
                });
                _context.next = 41;
                break;

              case 30:
                _context.prev = 30;
                _context.next = 33;
                return this.$validator({
                  remark: [(0, _validate.required)(_validate.required.message("备注"))]
                }).validate({
                  remark: remark
                });

              case 33:
                _context.next = 38;
                break;

              case 35:
                _context.prev = 35;
                _context.t2 = _context["catch"](30);
                return _context.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context.t2));

              case 38:
                data.mark = remark;
                data.orderNo = opt.orderId;
                (0, _order.orderMarkApi)(data).then(function (res) {
                  _this.$emit("closechange", false); // that.change = false;


                  that.$dialog.success('提交成功'); // that.$emit('init');
                  // that.init();
                }, function (err) {
                  _this.$emit("closechange", false); // that.change = false;


                  that.$dialog.error(err.message);
                });

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7], [16, 21], [30, 35]]);
      }));

      function savePrice(_x) {
        return _savePrice.apply(this, arguments);
      }

      return savePrice;
    }(),
    refuse: function () {
      var _refuse = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2() {
        var reason;
        return _index.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reason = this.reason;
                _context2.prev = 1;
                _context2.next = 4;
                return this.$validator({
                  reason: [(0, _validate.required)(_validate.required.message("备注"))]
                }).validate({
                  reason: reason
                });

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context2.t0));

              case 9:
                this.$emit("getRefuse", this.orderInfo.orderId, reason);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 6]]);
      }));

      function refuse() {
        return _refuse.apply(this, arguments);
      }

      return refuse;
    }()
  }
};
exports.default = _default;